<mtx-grid [data]="data" [columns]="columnGrid" [showColumnMenuHeader]="false"
[hidePageSize]="true" [noResultText]="'common.no_result' | translate" [showFirstLastButtons]="false" [rowStriped]="true" [showPaginator]="false"
[emptyValuePlaceholder]="'-'">
</mtx-grid>
